import { render } from "./derecha.vue?vue&type=template&id=75776b1e&scoped=true"
import script from "./derecha.vue?vue&type=script&lang=js"
export * from "./derecha.vue?vue&type=script&lang=js"

import "./derecha.vue?vue&type=style&index=0&id=75776b1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75776b1e"]])

export default __exports__